import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from '../../../../components/Box';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { ServiceIncomeTypeEnum } from '../../../../models/common/Enums';
import { GetAntrepoInByIdResponseAntrepoInVehicle, GetAntrepoInByIdResponseAntrepoInVehicleService } from '../../../../models/response/antrepoIn/GetAntrepoInByIdResponse';
import { GetServiceByIdResponse } from '../../../../models/response/service/GetServiceByIdResponse';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { ConstantService } from '../../../../services/ConstantService';
import { ServiceService } from '../../../../services/ServiceService';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import toast from "react-hot-toast";
import { GetAntrepoOutListByAntrepoInIdResponse } from '../../../../models/response/antrepoOut/GetAntrepoOutListByAntrepoInIdResponse';
import { AntrepoOutService } from '../../../../services/AntrepoOutService';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import CustomSwitch from '../../../../components/CustomSwitch';
import CustomTextInput from '../../../../components/CustomTextInput';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

interface Props {
    serviceInformationRef: any
    antrepoInVehicles: GetAntrepoInByIdResponseAntrepoInVehicle[]
    antrepoInVehicleServices: GetAntrepoInByIdResponseAntrepoInVehicleService[]
    setAntrepoInVehicleServices: React.Dispatch<React.SetStateAction<GetAntrepoInByIdResponseAntrepoInVehicleService[]>>
    antrepoInId: string | undefined
    ledgerNo: string | undefined
    isDisabledFromLock: boolean
}

const ServicesInformation = ({
    serviceInformationRef,
    antrepoInVehicles,
    antrepoInVehicleServices,
    setAntrepoInVehicleServices,
    antrepoInId,
    ledgerNo,
    isDisabledFromLock
}: Props) => {
    const auth = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedService, setSelectedService] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [quantity, setQuantity] = useState<string | undefined>(undefined);
    const [selectedMultiplier, setSelectedMultiplier] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [antrepoInVehicleServiceId, setAntrepoInVehicleServiceId] = useState<string | undefined>(undefined);
    const [multiplierList, setMultiplierList] = useState<CustomSingleSelectModel[]>([]);
    const [needQuantity, setNeedQuantity] = useState(false);
    const [willNotBeInvoiced, setWillNotBeInvoiced] = useState(false);
    const [willNotBeInvoicedReason, setWillNotBeInvoicedReason] = useState<string | undefined>(undefined);

    const saveItem = () => {
        if (willNotBeInvoiced && Helpers.isEmpty(willNotBeInvoicedReason)) {
            toast.error('Faturalanmama Nedeni alanını doldurunuz!')
            return;
        }

        if (Helpers.isEmpty(antrepoInVehicleServiceId)) {
            var o: GetAntrepoInByIdResponseAntrepoInVehicleService = {
                antrepoInVehicleServiceId: Helpers.generateUUID(true),
                isSelected: false,
                antrepoInVehicleId: antrepoInVehicles.filter(x => x.isSelected)[0].antrepoInVehicleId,
                groupNo: antrepoInVehicles.filter(x => x.isSelected)[0].groupNo,
                multiplierId: selectedMultiplier?.value,
                multiplierName: selectedMultiplier?.label,
                quantity: quantity,
                serviceId: selectedService?.value,
                serviceName: selectedService?.label,
                lastInvoicedDate: undefined,
                willNotBeInvoiced: willNotBeInvoiced,
                willNotBeInvoicedReason: willNotBeInvoicedReason,
            }

            setAntrepoInVehicleServices([...antrepoInVehicleServices, o])
        }
        else {
            setAntrepoInVehicleServices(antrepoInVehicleServices.map(function (x) {
                if (x.antrepoInVehicleServiceId == antrepoInVehicleServiceId) {
                    x.isSelected = false;
                    x.multiplierId = selectedMultiplier?.value;
                    x.multiplierName = selectedMultiplier?.label;
                    x.quantity = quantity;
                    x.serviceId = selectedService?.value;
                    x.serviceName = selectedService?.label
                    x.willNotBeInvoiced = willNotBeInvoiced;
                    x.willNotBeInvoicedReason = willNotBeInvoicedReason;
                }

                return x;
            }))
        }

        setAntrepoInVehicleServiceId('');
        onServiceSelected(undefined);
        setQuantity('');
        setSelectedMultiplier(undefined);
        setIsOpen(false);
        setWillNotBeInvoiced(false);
        setWillNotBeInvoicedReason('');
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = antrepoInVehicleServices.filter(x => x.isSelected)[0];

        setAntrepoInVehicleServiceId(o.antrepoInVehicleServiceId);
        onServiceSelected(o.serviceId && o.serviceName ? { label: o.serviceName, value: o.serviceId } : undefined);
        setQuantity(o.quantity);
        setSelectedMultiplier(o.multiplierId && o.multiplierName ? { label: o.multiplierName, value: o.multiplierId } : undefined);
        setWillNotBeInvoiced(o.willNotBeInvoiced);
        setWillNotBeInvoicedReason(o.willNotBeInvoicedReason);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAntrepoInVehicleServiceId('');
        onServiceSelected(undefined);
        setQuantity('');
        setSelectedMultiplier(undefined);
        setWillNotBeInvoiced(false);
        setWillNotBeInvoicedReason('');
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = serviceInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const setItemSelected = (_id: string) => {
        setAntrepoInVehicleServices(antrepoInVehicleServices.map(function (x) {
            if (x.antrepoInVehicleServiceId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const selectAll = () => {
        var isAllSelected = antrepoInVehicleServices.length == antrepoInVehicleServices.filter(x => x.isSelected).length;

        setAntrepoInVehicleServices(antrepoInVehicleServices.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const deleteItems = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            for (var i = 0; i < antrepoInVehicleServices.filter(x => x.isSelected).length; i++) {
                if (antrepoInId) {
                    var response2: GetAntrepoOutListByAntrepoInIdResponse = await AntrepoOutService.getAntrepoOutListByAntrepoInId(antrepoInId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    if (response2.data.length > 0) {
                        toast.error(ledgerNo + ' defter numaralı giriş kayıdına ait çıkış kayıdı olduğu için silme yapılamaz!')
                        return;
                    }
                }
            }

            setAntrepoInVehicleServices(antrepoInVehicleServices.filter(x => !x.isSelected));
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const onServiceSelected = async (selectedService: CustomSingleSelectModel | undefined) => {
        if (!selectedService) {
            setSelectedService(undefined);
            setMultiplierList([]);
            setNeedQuantity(false);
            return;
        }

        try {
            dispatch(storeActivityIndicator(true));

            var response: GetServiceByIdResponse = await ServiceService.getServiceById(selectedService.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setSelectedService(selectedService);
            setMultiplierList(response.data.serviceMultipliers);
            setNeedQuantity(response.data.needQuantity);

            if (!response.data.needQuantity)
                setQuantity('');
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <div className='containerPart' ref={serviceInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Ek Hizmetler</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hizmet Kalemi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedService}
                                            onChange={(selectedService) => {
                                                setSelectedMultiplier(undefined);
                                                onServiceSelected(selectedService)
                                            }}
                                            onMenuOpen={() => ServiceService.getServiceList(true, [ServiceIncomeTypeEnum.EK_HIZMET])}
                                            labelName='name'
                                            valueName='serviceId'
                                            additionalValue1Name={'incomePercentageName'}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Miktar</label>
                                        <CustomNumberInput isDisabled={!needQuantity} value={quantity} setValue={setQuantity} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Birim / Çarpan</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedMultiplier}
                                            onChange={setSelectedMultiplier}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: multiplierList
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                        />
                                    </div>
                                </div>

                                {
                                    auth.user.user?.data.roles.find(x => x == "Giriş Faturalandırma İşlemi Yetkisi") && (
                                        <div className="row mt-5">
                                            <div className='col-md-4'>
                                                <Box flexDirection='row'>
                                                    <Box>
                                                        <label htmlFor="exampleFormControlInput1" className="form-label">Faturalanmayacak</label>
                                                        <CustomSwitch
                                                            setIsActive={() => {
                                                                if (willNotBeInvoiced)
                                                                    setWillNotBeInvoicedReason('');

                                                                setWillNotBeInvoiced(!willNotBeInvoiced)
                                                            }}
                                                            isActive={willNotBeInvoiced}
                                                        />
                                                    </Box>

                                                    {
                                                        willNotBeInvoiced && (
                                                            <Box ml='15px' flexGrow={1}>
                                                                <label htmlFor="exampleFormControlInput1" className="form-label required">Faturalanmama Nedeni</label>
                                                                <CustomTextInput value={willNotBeInvoicedReason} setValue={setWillNotBeInvoicedReason} />
                                                            </Box>
                                                        )
                                                    }
                                                </Box>
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    {
                        !isDisabledFromLock && (
                            <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                                <Box onClick={antrepoInVehicles.filter(a => a.isSelected).length == 1 ? cancelAdding : undefined} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={antrepoInVehicles.filter(a => a.isSelected).length == 1 ? "1" : "0.5"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                                    </Box>
                                </Box>

                                <Box onClick={antrepoInVehicleServices.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={antrepoInVehicleServices.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className="text-white fa fa-edit" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                                    </Box>
                                </Box>

                                <Box onClick={antrepoInVehicleServices.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={antrepoInVehicleServices.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className="text-white fa fa-trash" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                                    </Box>
                                </Box>
                            </Box>
                        )
                    }

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                {
                                                    !isDisabledFromLock && (
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={selectAll} className='form-check-input' type='checkbox' checked={antrepoInVehicleServices.filter(x => x.isSelected).length > 0 && antrepoInVehicleServices.filter(x => x.isSelected).length == antrepoInVehicleServices.length} />
                                                            </label>
                                                        </div>
                                                    )
                                                }
                                            </th>
                                            <th>Grup Sıra No</th>
                                            <th>Hizmet Kalemi</th>
                                            <th>Miktar</th>
                                            <th>Birim / Çarpan</th>
                                            {auth.user.user?.data.roles.find(x => x == "Giriş Faturalandırma İşlemi Yetkisi") && <th>Faturalanmayacak</th>}
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoInVehicleServices.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoInVehicleServices.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        {
                                                            !isDisabledFromLock && (
                                                                <div className='d-flex'>
                                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                        <input onChange={() => setItemSelected(item.antrepoInVehicleServiceId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                    </label>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    <td>{item.groupNo}</td>
                                                    <td>{item.serviceName}</td>
                                                    <td className='custom-text-right'>{item.quantity}</td>
                                                    <td>{item.multiplierName}</td>
                                                    {
                                                        auth.user.user?.data.roles.find(x => x == "Giriş Faturalandırma İşlemi Yetkisi") && (
                                                            <td>
                                                                <Box flexDirection="row">
                                                                    <Box justifyContent="center">
                                                                        {item.willNotBeInvoiced ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}
                                                                    </Box>
                                                                    {
                                                                        !Helpers.isEmpty(item.willNotBeInvoicedReason) && (
                                                                            <Box ml="5px" justifyContent="center">
                                                                                {item.willNotBeInvoicedReason}
                                                                            </Box>
                                                                        )
                                                                    }
                                                                </Box>
                                                            </td>
                                                        )
                                                    }
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ServicesInformation;